const { animate, inView, stagger, anime, scrollDirection, Splitting } = window;

function do_animation(targets, opacity = 1, translateY = [30, 0], scale = [0.95, 1]) {
    anime({
        targets: targets,
        opacity: opacity,
        translateY: translateY,
        scale: scale,
        duration: 200,
        delay: anime.stagger(140),
        easing: 'easeInElastic(1, .6)'
    });
}

function do_animation_link(link, translate = [-30, 0], scale = 1) {
    anime({
        targets: link,
        opacity: 1,
        translateY: translate,
        scale: scale,
        duration: 100,
        easing: 'easeInElastic(1, .6)'
    });
}

document.querySelectorAll('main .wp-block-klx-bento').forEach(bento => {
    inView(bento, (_) => {
        var _bento = bento.querySelectorAll('.wp-block-klx-bento-item');
        if (window.scrollDirection === 'up') {
            _bento = Array.from(_bento).reverse();
        }
        do_animation(_bento, 1, [30, 0], [0.95, 1]);
        return (_) => {
            do_animation(_bento, 0, [0, 30], [1, 0.95]);
        }
    })
})


document.querySelectorAll('.wp-block-klx-bento > a').forEach(link => {
    link.addEventListener('mouseenter', () => {
        do_animation_link(link, [0, -5], [1, 1.02]);
    });

    link.addEventListener('mouseleave', () => {
        do_animation_link(link, [-5, 0], [1.01, 1]);
    });
});


Splitting({
    /* target: String selector, Element, Array of Elements, or NodeList */
    target: "a.wp-block-klx-bento-item h2",
    /* by: String of the plugin name */
    by: "chars",
    /* key: Optional String to prefix the CSS variables */
    key: null
});